import { TextInput, Text, Card, Group, Textarea, Stack } from '@mantine/core';
import { type UseFormReturnType } from '@mantine/form';
import { type CreateClient } from '@/schemas/API/POST/client/request';

interface ContactPersonCardProps {
    title: string;
    formContext: () => UseFormReturnType<CreateClient>;
    disabled?: boolean;
}

export const ContactPersonCard: React.FC<ContactPersonCardProps> = (props) => {
    const form = props.formContext();

    return (
        <Card shadow="sm" padding="md" radius="md" withBorder>
            <Text fw={700} size="large">
                {props.title}
            </Text>
            <Group justify="space-between" grow className="flex items-start">

                <TextInput
                    variant="filled"
                    label="Titul"
                    w="100%"
                    {...form.getInputProps('contacts.0.title')}
                    disabled={props.disabled}
                />

                <TextInput
                    variant="filled"
                    label="Jméno"
                    w="100%"
                    {...form.getInputProps('contacts.0.firstName')}
                    disabled={props.disabled}
                />

                <TextInput
                    variant="filled"
                    label="Příjmení"
                    w="100%"
                    {...form.getInputProps('contacts.0.lastName')}
                    disabled={props.disabled}
                />
            </Group>
            <Group justify="space-between" grow className="flex items-start" mt="md">

                <TextInput
                    variant="filled"
                    label="Vztah ke klientovi"
                    w="100%"
                    {...form.getInputProps('contacts.0.relation')}
                    disabled={props.disabled}
                />

                <TextInput
                    variant="filled"
                    label="E-mail"
                    w="100%"
                    {...form.getInputProps('contacts.0.email')}
                    disabled={props.disabled}
                />

                <TextInput
                    variant="filled"
                    label="Telefon"
                    w="100%"
                    {...form.getInputProps('contacts.0.phone')}
                    disabled={props.disabled}
                />
            </Group>
            <Stack className="mt-6">
                <Textarea
                    variant="filled"
                    label="Popis stavu klienta"
                    autosize
                    minRows={2}
                    maxRows={6}
                    {...form.getInputProps('applicantData.statusDesc')}
                    disabled={props.disabled}
                />

                <Textarea
                    variant="filled"
                    label="Poznámka"
                    autosize
                    minRows={2}
                    maxRows={6}
                    {...form.getInputProps('applicantData.note')}
                    disabled={props.disabled}
                />
            </Stack>
        </Card>
    );
};
